import { createBrowserRouter } from "react-router-dom";
import Home from "../app/page";

const component = (load: () => Promise<{ default: React.ComponentType }>) => async () => ({
  Component: (await load()).default,
});

function RouteError() {
  return (
    <main className="page" role="alert">
      <div className="card">
        <h1>Something went wrong</h1>
        <p className="text-muted">The page could not be loaded. Please try again.</p>
        <a className="btn btn-primary" href="/">Return home</a>
      </div>
    </main>
  );
}

function NotFound() {
  return (
    <main className="page">
      <div className="card">
        <h1>Page not found</h1>
        <a href="/dashboard">Go to dashboard</a>
      </div>
    </main>
  );
}

export const router = createBrowserRouter([
  { path: "/", Component: Home, errorElement: <RouteError /> },
  { path: "/login", lazy: component(() => import("../app/login/page")) },
  { path: "/legal/privacy-policy", lazy: component(() => import("../app/legal/privacy-policy/page")) },
  { path: "/legal/terms-of-use", lazy: component(() => import("../app/legal/terms-of-use/page")) },
  { path: "/dashboard", lazy: component(() => import("../app/dashboard/page")) },
  { path: "/chat", lazy: component(() => import("../app/chat/page")) },
  { path: "/models", lazy: component(() => import("../app/models/page")) },
  { path: "/api-keys", lazy: component(() => import("../app/api-keys/page")) },
  { path: "/billing", lazy: component(() => import("../app/billing/page")) },
  { path: "/analytics", lazy: component(() => import("../app/analytics/page")) },
  { path: "/analytics/activity", lazy: component(() => import("../app/analytics/page")) },
  { path: "/analytics/usage", lazy: component(() => import("../app/analytics/page")) },
  { path: "/analytics/logs", lazy: component(() => import("../app/analytics/page")) },
  { path: "/settings", lazy: component(() => import("../app/settings/page")) },
  { path: "*", Component: NotFound },
]);
